import LegalPage from "../components/layout/LegalPage";
import { TERMS_SECTIONS, LEGAL_EFFECTIVE_DATE } from "../data/legalData";

const TermsPage = () => (
    <LegalPage
        title="Terms of Use"
        effectiveDate={LEGAL_EFFECTIVE_DATE}
        sections={TERMS_SECTIONS}
    />
);

export default TermsPage;
